package features.overtime.handlers

import kotlinx.browser.window
import AppState
import features.overtime.data.OvertimeRepository

/**
 * Debug function to log all overtime data to console
 * This will NOT export to CSV, only show data in console for validation
 */
fun debugOvertimeData() {
    val team = AppState.currentTeam
    val teamId = team?.id
    
    if (team == null || teamId == null) {
        window.alert("No team selected")
        return
    }
    
    console.log("📊 Fetching overtime data for team: ${team.name}")
    
    // Fetch overtime requests from Firebase
    OvertimeRepository.getOvertimeRequests(teamId)
        .then { requests ->
            // Get members for name lookup
            val members = AppState.members[teamId] ?: emptyList()
            
            // ========== DEBUG: Show all fetched data ==========
            console.log("========================================")
            console.log("📊 OVERTIME DATA DEBUG")
            console.log("========================================")
            console.log("Team ID: $teamId")
            console.log("Team Name: ${team.name}")
            console.log("Total Requests: ${requests.size}")
            console.log("----------------------------------------")
            
            console.log("Total Members in AppState: ${members.size}")
            members.forEach { member ->
                console.log("  - Member: ${member.name} (ID: ${member.id})")
            }
            console.log("----------------------------------------")
            
            // Log each request in detail
            requests.forEachIndexed { index, request ->
                val member = members.find { it.id == request.userId }
                val memberName = member?.name ?: "Unknown (ID: ${request.userId})"
                
                console.log("Request #${index + 1}:")
                console.log("  Member: $memberName")
                console.log("  Date: ${request.date}")
                console.log("  Start Time: ${request.startTime}")
                console.log("  End Time: ${request.endTime}")
                console.log("  Hours: ${request.hours}")
                console.log("  Status: ${request.status}")
                console.log("  Reason: ${request.reason}")
                console.log("  Submitted: ${request.createdAt}")
                console.log("  ---")
            }
            console.log("========================================")
            // ========== END DEBUG ==========
            
            window.alert("✅ Overtime data logged to console! Check browser console (F12) for details.\nTotal requests: ${requests.size}")
        }
        .catch { error ->
            console.error("❌ Failed to fetch overtime data:", error)
            window.alert("Failed to fetch overtime data. Please try again.")
        }
}
